import axios from 'axios';
import { environments, normalize } from 'gatsby-theme-apollo';

const createUpdatePost = async ({ id, contentJSON, authorID, title, games, gameName }) => {
  const method = id ? `PUT` : `POST`;

  let url = `${environments.rest}/posts`;

  let data = {
    contentJSON,
    author: authorID,
    title,
    games,
    publish: true
  };

  if (id) {
    url = `${url}/${id}`;
  } else {
    const permalink = normalize.hyphenateAndLowerCase(`/${gameName}/news/${title}/`);
    data = {
      ...data,
      permalink
    };
  }

  const saveResult = await axios({
    method,
    url,
    data
  })
    .then(response => {
      return [response.data];
    })
    .catch(err => {
      console.log(`Something went wrong saving Post.`, err);
      return [null, err];
    });

  return saveResult;
};

const postAuthor = async ({ baseURI, userAuthID }) => {
  const saveResult = await axios({
    method: 'POST',
    url: `${baseURI}/authors`,
    data: {
      authid: userAuthID
    }
  })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error('error creating author', ': ', err);
      return false;
    });

  return saveResult;
};

const postTip = async ({ authorID, entityID, text }) => {
  return await axios({
    method: 'POST',
    url: `${environments.rest}/tips`,
    data: {
      author: authorID,
      character: entityID,
      text
    }
  })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      console.error('error creating tip', text, ': ', err);
      return false;
    });
};

export { postAuthor, postTip, createUpdatePost };
